"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _Table = require("../Table.styles");

var DraggingTableRowCells = function DraggingTableRowCells(_ref) {
  var colSpan = _ref.colSpan;
  return (0, _jsxRuntime.jsx)("td", {
    css: _Table.styles.draggingCell,
    colSpan: colSpan,
    children: "\xA0"
  });
};

DraggingTableRowCells.displayName = 'DraggingTableRowCells';
DraggingTableRowCells.propTypes = {
  colSpan: _propTypes.number.isRequired
};
DraggingTableRowCells.defaultProps = {};
var _default = DraggingTableRowCells;
exports["default"] = _default;
//# sourceMappingURL=DraggingTableRowCells.js.map